export var TEMPLATE_VERSION = 4;

//# sourceMappingURL=/home/travis/build/ractivejs/ractive/.gobble-build/01-transpile/.cache/config/template.js.map
